<template>
  <div class="col-lg-12 control-section">
    <div class="tree-control-wrapper">
      <ejs-treeview 
      ref='additionalNeTree' 
      id='additionalNeTree' 
      :fields='fields' 
      :nodeChecked='nodeChecked'
      :showCheckBox='true' ></ejs-treeview>
    </div>
  </div>
</template>

<script>
import commonUtil from '../RealTimeTask/commonUtil';

export default {
  name: 'AdditionalNeTree',
  props: [
  ],
  data() {
    return {
      fields: {
        dataSource: [{ children: [] }],
        id: 'id',
        text: 'text',
        child: 'children',
        expanded: 'state',
      },
      neTypeId: 101,
      selectNeIds: new Set(),
    };
  },
  methods: {
   nodeChecked() {
        console.log(arguments);
        if (arguments[0].action == 'check') {
            this.selectNeIds.add(arguments[0].data[0].id);
        }

        if (arguments[0].action == 'uncheck') {
            this.selectNeIds.delete(arguments[0].data[0].id);
        }
   },
   getNeTreeForDataSearch(queryStrParam) {
      this.$axios.post(`/lte/pm/getNeTree.html?queryStr=${queryStrParam}&systemId=1&neTypeId=101&neVersionId=V16B.006`).then((response) => {
        this.fields = {
          dataSource: response.data,
          id: 'id',
          text: 'text',
          child: 'children',
          expanded: 'state',
          tooltip: 'text'
        };
      });
    },
  },
  mounted() {
  }
};
</script>

<style>

</style>
